import { findRelationshipIdFromTarget, getNewRelationshipId, insertNewRelationship } from './document-rels.js';

/**
 * Collection of utility functions for working with docx files in the Super Editor.
 */
export const DocxHelpers = {
  findRelationshipIdFromTarget,
  insertNewRelationship,
  getNewRelationshipId,
};
